import { render, staticRenderFns } from "./head_big.vue?vue&type=template&id=c408f146&scoped=true&"
import script from "./head_big.vue?vue&type=script&lang=js&"
export * from "./head_big.vue?vue&type=script&lang=js&"
import style0 from "./head_big.vue?vue&type=style&index=0&id=c408f146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c408f146",
  null
  
)

export default component.exports